import { format } from "date-fns";
import { DataTableColumnHeader } from "../table-components/data-table-column-header";
import LocationAddress from "../../../../components/app/shared/LocationComponent";

export const baseColumns = [
  // {
  //   id: "_id",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Job ID" />
  //   ),
  //   accessorKey: "_id",
  //   cell: (info) => (
  //     <div className="font-mono text-xs truncate max-w-24">
  //       {info.getValue()}
  //     </div>
  //   ),
  // },
  {
    id: "jobStatus",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Job Status" />
    ),
    accessorKey: "jobStatus",
  },
  {
    id: "homeOwner",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Home Owner" />
    ),
    accessorFn: (row) => ({
      name: row.houseOwnerId
        ? `${row.houseOwnerId.firstName || "N/A"} ${row.houseOwnerId.lastName || "N/A"}`
        : "N/A",
      username: row.houseOwnerId?.userName || "N/A",
    }),
    cell: (info) => (
      <div>
        <div className="whitespace-nowrap">{info.getValue().name}</div>
        <div style={{ fontSize: "0.85em", color: "#666" }}>
          {info.getValue().username}
        </div>
      </div>
    ),
    filterFn: (row, columnId, filterValue) => {
      const owner = row.original.houseOwnerId;
      if (!owner) return false;
      const name = `${owner.firstName || ""} ${owner.lastName || ""}`.toLowerCase();
      const username = (owner.userName || "").toLowerCase();
      const filter = filterValue.toLowerCase();
      return name.includes(filter) || username.includes(filter);
    },
  },
  {
    id: "contact",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Contact" />
    ),
    accessorFn: (row) => ({
      email: row.houseOwnerId?.email || "N/A",
      phone: row.houseOwnerId?.phone || "N/A",
    }),
    cell: (info) => (
      <div>
        <div className="whitespace-nowrap">{info.getValue().email}</div>
        <div style={{ fontSize: "0.85em", color: "#666" }}>
          {info.getValue().phone}
        </div>
      </div>
    ),
    filterFn: (row, columnId, filterValue) => {
      const owner = row.original.houseOwnerId;
      if (!owner) return false;
      const email = (owner.email || "").toLowerCase();
      const phone = (owner.phone || "").toLowerCase();
      const filter = filterValue.toLowerCase();
      return email.includes(filter) || phone.includes(filter);
    },
  },
  {
    id: "address",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Address" />
    ),
    accessorFn: (row) => {
      const owner = row.houseOwnerId;
      return {
        address: owner
          ? `${owner.address || "N/A"} ${owner.city || "N/A"} ${owner.province || "N/A"} ${owner.country || "N/A"}`
          : "N/A",
        postalCode: owner?.postalCode || "N/A",
      };
    },
    cell: (info) => (
      <div className="flex flex-col min-w-32">
        <div className="line-clamp-2">{info.getValue().address}</div>
        <div style={{ fontSize: "0.85em", color: "#666" }}>
          {info.getValue().postalCode}
        </div>
      </div>
    ),
    filterFn: (row, columnId, filterValue) => {
      const owner = row.original.houseOwnerId;
      if (!owner) return false;
      const address = `${owner.address || ""} ${owner.city || ""} ${owner.province || ""} ${owner.country || ""}`.toLowerCase();
      const postalCode = (owner.postalCode || "").toLowerCase();
      const filter = filterValue.toLowerCase();
      return address.includes(filter) || postalCode.includes(filter);
    },
  },
  {
    id: "location",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Location" />
    ),
    accessorFn: (row) => {
      const coords = row.location?.coordinates || [];
      return coords.length === 2
        ? `${coords[1].toFixed(6)}, ${coords[0].toFixed(6)}`
        : "N/A";
    },
    cell: (info) => {
      const coords = info.row.original.location?.coordinates || [];
      return <div className="font-mono text-xs min-w-[15rem]">
        <LocationAddress latitude={coords[1]} longitude={coords[0]} />
      </div>
    },
  },
  {
    id: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created At" />
    ),
    accessorFn: (row) =>
      row.createdAt
        ? format(new Date(row.createdAt), "do MMM, yyyy 'at' h:mma")
        : "N/A",
  },
  {
    id: "authorizationDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Authorization Date" />
    ),
    accessorFn: (row) =>
      row.authorizationDate
        ? format(new Date(row.authorizationDate), "do MMM, yyyy 'at' h:mma")
        : "N/A",
  },
  {
    id: "referredBy",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Referred By" />
    ),
    accessorKey: "referredBy",
    cell: (info) => info.getValue() || "N/A",
  },
];
